var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypePicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41979_9101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0.0322266C1.34315 0.0322266 0 1.37537 0 3.03223V13.0322C0 14.6891 1.34315 16.0322 3 16.0322H13C14.6569 16.0322 16 14.6891 16 13.0322V3.03223C16 1.37537 14.6569 0.0322266 13 0.0322266H3ZM9.12193 2.84541C9.75311 2.84541 10.2648 3.3571 10.2648 3.98827C10.2648 4.61944 9.75311 5.13113 9.12193 5.13113C8.49076 5.13113 7.97908 4.61944 7.97908 3.98827C7.97908 3.3571 8.49076 2.84541 9.12193 2.84541ZM13.1868 11.3121C13.1868 12.3653 12.3331 13.219 11.2799 13.219H4.46146C3.55115 13.219 2.81319 12.4811 2.81319 11.5708C2.81319 11.1489 2.97493 10.7431 3.26513 10.4369L4.09404 9.56231C5.0358 8.56864 6.56604 8.42149 7.6799 9.21748L8.09203 9.512C8.7189 9.95998 9.55014 9.99892 10.2161 9.61152C11.0016 9.15465 11.9981 9.29782 12.6232 9.95733L12.664 10.0004C12.9997 10.3546 13.1868 10.8241 13.1868 11.3121Z",
    fill: "#6576FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41979_9101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0322266)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypePicture);
export default __webpack_public_path__ + "static/media/typePicture.4f00126e.svg";
export { ForwardRef as ReactComponent };